import { createRouter, createWebHashHistory } from 'vue-router'
import { routeList } from '@/router/helpers/routes'
import { validateRoute } from '@/router/helpers/validations'

/* Modules */
import approvals from '@/router/modules/approvals'
import accounts from '@/router/modules/accounts'
import agencies from '@/router/modules/agencies'
import bankassurance from '@/router/modules/bankassurance'
import cards from '@/router/modules/cards'
import companyPayments from '@/router/modules/companyPayments'
import contacts from '@/router/modules/contacts'
import credits from '@/router/modules/credits'
import exchanges from '@/router/modules/exchanges'
import favorites from '@/router/modules/favorites'
import initialActions from '@/router/modules/initialActions'
import nonAuthenticated from '@/router/modules/nonAuthenticated'
import payments from '@/router/modules/payments'
import savings from '@/router/modules/savings'
import transfers from '@/router/modules/transfers'
import userArea from '@/router/modules/userArea'
/* Non-Authenticated Views */
import Login from '@/views/nonAuthenticated/Login'
import AuthorizeSession from '@/views/nonAuthenticated/AuthorizeSession'
import HomeWeb from '@/views/home/HomeWeb'

/* Views */
// Insert Authenticated Views
import UnderDevelopment from '@/views/UnderDevelopment'

const baseRoutes = [
	{
		path: routeList.LOGIN_PATH,
		name: routeList.LOGIN_NAME,
		props: true,
		component: Login
	},
	{
		path: routeList.HOME_PATH,
		name: routeList.HOME_NAME,
		component: HomeWeb
	},
	{
		path: routeList.AUTHORIZE_SESSION_PATH,
		name: routeList.AUTHORIZE_SESSION_NAME,
		component: AuthorizeSession,
		props: true,
		beforeEnter (to, from, next) {
			if (!to.query || !to.query.processId) {
				next('/')
			} else {
				to.params.processId = to.query.processId
				next()
			}
		}
	},
	/* this empty route is for us to handle mobileMenu and handle refresh automatic */
	{ path: '/mobileMenuhome', component: UnderDevelopment },
	{
		path: '/:pathMatch(.*)*',
		component: UnderDevelopment
	}
]

/* Design System Showroom, we are doing this here, to make sure these route wont be handle if user manually type it */
if (process.env.VUE_APP_SHOW_DESIGN_SHOWROOM === 'true') {
	baseRoutes.push(
	{
		path: routeList.DESIGN_SHOWROOM_PATH,
		name: routeList.DESIGN_SHOWROOM_NAME,
		component: () => import('@/designShowroom/DesignShowroom'),
		beforeEnter (to, from, next) {
			if (!to.hash.length) {
				next({ path: routeList.DESIGN_SHOWROOM_PATH, hash: routeList.DESIGN_SHOWROOM_FIRST_ENTRY })
			} else next()
		},
		/* Route added for navigation components tests without leaving our current route */
		children: [{
			path: 'randomLinkForTest',
			beforeEnter (to, from, next) { next(false) }
		}]
	})
}

const routes = baseRoutes.concat(
	approvals,
	accounts,
	agencies,
	bankassurance,
	cards,
	companyPayments,
	contacts,
	credits,
	exchanges,
	favorites,
	initialActions,
	nonAuthenticated,
	payments,
	savings,
	transfers,
	userArea
)

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

/* navigation guard for access */
router.beforeEach((to, from, next) => {
	validateRoute(to, from, next)
})

export default router
